<template>
  <div id="RegisterPage">
    <!-- Form + Steps for Registeration -->
    <section v-if="!isRegisterSuccess" class="section">
      <b-steps
        v-model="activeStep"
        :animated="true"
        :has-navigation="false"
        type="is-info"
      >
        <b-step-item
          :label="$t('register.service_area')"
          icon="map-marker-radius"
          :clickable="false"
          :type="{ 'is-success': isCheckServiceSuccess }"
        >
          <location-map
            :isForm="false"
            :type="'service'"
            :clear="isClearMarker"
            @update_myLocationWatchID="setmyLocationWatchID"
            @update_service_area_status="updateServiceLocationToken"
            @go_to_number_register_active="navigateToFormRegisterStep"
          />
        </b-step-item>

        <b-step-item
          :label="$t('register.number_register')"
          icon="account-plus"
          :clickable="false"
          :type="{ 'is-success': isRegisterSuccess }"
        >
          <register-form
            :restate="isClearRegisterForm"
            :locToken="locationToken"
            :conToken="contactToken"
            :contact="contactQuery"
            @update_register_complete="updateRegisterStep"
          />
        </b-step-item>
      </b-steps>
      <!-- Button Step Back -->
      <b-button
        class="dtac-font"
        v-if="showBackButton"
        @click.prevent="navigateToCheckServiceStep()"
      >
        {{ $t("register.form.back_btn") }}
      </b-button>
    </section>
    <!-- Success Register -->
    <section v-else class="section">
      <div class="columns is-centered">
        <div class="column is-two-fifths">
          <b-notification type="is-success" has-icon @close="reloadPage">
            <p class="title is-3">
              {{ $t("register.form.success_register.title") }}
            </p>
            <p class="subtitle is-6" style="line-height: 1.8rem;">
              {{ $t("register.form.success_register.content.msisdn") }}:
              {{ customerProfile.msisdn }}
              <br />
              {{ $t("register.form.success_register.content.contact_number") }}:
              {{ customerProfile.contact_number }}
              <br />
              {{ $t("register.form.success_register.content.imie") }}:
              {{ customerProfile.imei }}
            </p>
            <p class="subtitle is-6">
              {{ $t("register.form.success_register.content.date_created") }}:
              {{ customerProfile.created.time | dateformatter }}
            </p>
          </b-notification>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import dayjs from "dayjs";
import LocationMap from "@/components/maps/LocationMap.vue";
import RegisterForm from "@/components/forms/RegisterForm.vue";

export default {
  name: "RegisterPage",
  components: {
    LocationMap,
    RegisterForm
  },
  data() {
    return {
      activeStep: 0,
      showNextButton: false,
      showBackButton: false,
      isClearMarker: false,
      isClearRegisterForm: false,
      isRegisterSuccess: false,
      isCheckServiceSuccess: false,
      watchLocationID: null,
      locationToken: "",
      contactToken: "",
      contactQuery: null,
      customerProfile: {}
    };
  },
  watch: {
    activeStep: function(val) {
      switch (val) {
        case 1:
          this.showBackButton = true;
          break;

        default:
          this.showBackButton = false;
          break;
      }
    }
  },
  filters: {
    dateformatter: function(value) {
      if (!value) return "";
      return dayjs(value).format("DD/MM/YYYY @ HH:mm");
    }
  },
  methods: {
    updateServiceLocationToken: function(value) {
      this.locationToken = value.token;
    },
    updateRegisterStep: function(value) {
      this.locationToken = "";
      this.isRegisterSuccess = true;
      this.customerProfile = value;
    },
    setmyLocationWatchID: function(value) {
      this.watchLocationID = value;
    },
    navigateToFormRegisterStep: function() {
      this.isClearMarker = true;
      this.isClearRegisterForm = false;
      this.showNextButton = false;
      this.isCheckServiceSuccess = true;
      this.activeStep = 1;
    },
    navigateToCheckServiceStep: function() {
      this.isClearMarker = false;
      this.isClearRegisterForm = true;
      this.isCheckServiceSuccess = false;
      this.activeStep = 0;
    },
    reloadPage: function() {
      this.activeStep = 0;
      this.locationToken = "";
      this.isRegisterSuccess = false;
    }
  },
  mounted() {
    const prospectContactToken = this.$route.query.c_token;
    const prospectLocationToken = this.$route.query.p_token;
    if (
      prospectLocationToken &&
      prospectLocationToken !== "" &&
      prospectContactToken &&
      prospectContactToken !== ""
    ) {
      this.contactToken = prospectContactToken;
      this.locationToken = prospectLocationToken;
      this.contactQuery = this.$route.query.contact;
      this.navigateToFormRegisterStep();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.watchLocationID) {
      navigator.geolocation.clearWatch(this.watchLocationID);
    }
    next();
  }
};
</script>

<style scoped>
.padding {
  padding: 2rem 0;
}
</style>
